export default __webpack_public_path__ + "static/media/pay respects 6.4f7187fb.png";